import {
  Button,
  EditIcon,
  Flex,
  Skeleton,
  Typography,
} from '@iheartjane/reefer';
import { Table } from '@iheartjane/reefer-table';

import {
  CollapsedBorderTable,
  TableRowWithBorder,
} from '@jane/business-admin/components/TableWithBorderSeparator';
import { BODY_LINE_HEIGHT } from '@jane/business-admin/util';

export const LoadingMenuRowsTable = ({ arraySize }: { arraySize: number }) => (
  <CollapsedBorderTable>
    <Table.Head>
      <Table.Row>
        <Table.HeaderCell>
          <Typography variant="caps-regular" color="grays-mid">
            Name
          </Typography>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <Typography variant="caps-regular" color="grays-mid">
            Visibility
          </Typography>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Head>
    <Table.Body>
      {Array.from({ length: arraySize }, (_, index) => {
        return (
          <TableRowWithBorder key={`loading_${index}`} hasBorder={true}>
            <td width="75%">
              <Skeleton animate width="80%">
                <Skeleton.Bone height={BODY_LINE_HEIGHT} my={16} width="100%" />
              </Skeleton>
            </td>
            <td>
              <Skeleton animate width="100%">
                <Skeleton.Bone height={BODY_LINE_HEIGHT} my={16} width="80%" />
              </Skeleton>
            </td>
          </TableRowWithBorder>
        );
      })}
    </Table.Body>
  </CollapsedBorderTable>
);

export const LoadingMenuRows = () => {
  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" mb={0}>
        <Typography variant="h2-semibold">Menu rows</Typography>
        <Button.Icon
          ariaLabel="edit menu products product groups"
          icon={<EditIcon />}
          variant="secondary"
          disabled={true}
        />
      </Flex>
      <LoadingMenuRowsTable arraySize={3} />
    </>
  );
};
